import { Edit, Form, Input, InputNumber, Select, Switch, useForm, useSelect } from '@pankod/refine-antd';
import { IResourceComponentsProps, useShow } from '@pankod/refine-core';
import 'react-mde/lib/styles/css/react-mde-all.css';
import { ICrate } from 'types/crate.interface';
import { IGenre } from 'types/genre.interface';
import { ILabel } from 'types/label.interface';
import { ITag } from 'types/tag.interface';
import { ITrackKey } from 'types/trackkey.interface';
import { IUser } from 'types/user.interface';
import './styles.scss';
import { SoftOptions } from './utils';
import datetimeService from 'services/datetime.service';
import { useState } from 'react';

export const CrateEdit: React.FC<IResourceComponentsProps> = () => {
    const { formProps, saveButtonProps, formLoading } = useForm<ICrate>();
    const [bmpStart, setBmpStart] = useState<number>(0);
    const [bmpEnd, setBmpEnd] = useState<number>(0);
    const { queryResult } = useShow<ICrate>();
    const { data, isLoading } = queryResult;
    const record: any = data && data?.data;

    const { selectProps: GenreSelectProps } = useSelect<IGenre>({
        resource: 'genres',
        fetchSize: 100,
        optionLabel: 'name',
        optionValue: '_id',
    });

    const { selectProps: TagSelectProps } = useSelect<ITag>({
        resource: 'tags',
        fetchSize: 100,
        optionLabel: 'name',
        optionValue: '_id',
    });

    const { selectProps: LabelSelectProps } = useSelect<ILabel>({
        resource: 'labels',
        fetchSize: 100,
        optionLabel: 'name',
        optionValue: '_id',
    });

    const { selectProps: UserSelectProps } = useSelect<IUser>({
        resource: 'users',
        fetchSize: 100,
        optionLabel: 'username',
        optionValue: '_id',
    });

    const { selectProps: TrackKeySelectProps } = useSelect<ITrackKey>({
        resource: 'track-keys',
        fetchSize: 100,
        optionLabel: 'musicKey',
        optionValue: '_id',
    });

    return (
        <Edit saveButtonProps={saveButtonProps} isLoading={isLoading || formLoading}>
            <Form {...formProps} layout='vertical'>
                <Form.Item
                    label='Name'
                    name='name'
                    rules={[
                        {
                            required: true,
                            message: 'Name is required',
                        },
                    ]}
                    initialValue={record?.data.name}
                >
                    <Input />
                </Form.Item>

                {/* <div className="edit-title">
          <Form.Item
            className="edit-item w48"
            label="BpmFrom"
            name="bpmFrom"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input defaultValue={record?.data.bpmFrom} type="number" />
          </Form.Item>

          <Form.Item
            className="edit-item w48"
            label="BpmTo"
            name="bpmTo"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input defaultValue={record?.data.bpmTo} type="number" />
          </Form.Item>
        </div>
        <div className="edit-title">
          <Form.Item
            className="edit-item w48"
            label="PriceFrom"
            name="priceFrom"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input defaultValue={record?.data.priceFrom} type="number" />
          </Form.Item>

          <Form.Item
            className="edit-item w48"
            label="PriceTo"
            name="priceTo"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input defaultValue={record?.data.priceTo} type="number" />
          </Form.Item>
        </div>
        <div className="edit-title">
          <Form.Item
            className="edit-item w48"
            label="YearFrom"
            name="yearFrom"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input defaultValue={record?.data.yearFrom} type="number" />
          </Form.Item>

          <Form.Item
            className="edit-item w48"
            label="YearTo"
            name="yearTo"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input defaultValue={record?.data.yearTo} type="number" />
          </Form.Item>
        </div> */}

                <Form.Item
                    label='ShowGenres'
                    name='showGenres'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <Select mode='multiple' {...GenreSelectProps} defaultValue={record?.data?.showGenres ? record?.data?.showGenres?.map((tag: ITag) => tag._id) : []} />
                </Form.Item>
                <Form.Item
                    label='ShowTags'
                    name='showTags'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <Select mode='multiple' {...TagSelectProps} defaultValue={record?.data?.showTags ? record?.data?.showTags?.map((tag: ITag) => tag._id) : []} />
                </Form.Item>

                <Form.Item
                    label='Label'
                    name='labelId'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <Select {...LabelSelectProps} defaultValue={record?.data?.labelId && record?.data?.labelId.name} />
                </Form.Item>

                <Form.Item
                    label='ShowContributors'
                    name='showContributors'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <Select mode='multiple' {...UserSelectProps} defaultValue={record?.data?.showContributors ? record?.data?.showContributors?.map((tag: ITag) => tag._id) : []} />
                </Form.Item>
                <Form.Item
                    label='ShowTrackKeys'
                    name='showTrackKeys'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <Select mode='multiple' {...TrackKeySelectProps} defaultValue={record?.data?.showTrackKeys ? record?.data?.showTrackKeys?.map((tag: ITag) => tag._id) : []} />
                </Form.Item>
                <Form.Item
                    label='User'
                    name='user'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <Select disabled {...UserSelectProps} defaultValue={record?.data?.user?.email} />
                </Form.Item>
                {/* <div style={{ display: "flex" }}>
          <Form.Item
            label="clean"
            name="clean"
            rules={[
              {
                required: false,
              },
            ]}
            style={{ width: "20%", marginRight: "10%" }}
          >
            <Checkbox defaultChecked={record?.data?.clean} />
          </Form.Item>
          <Form.Item
            label="Dirty"
            name="dirty"
            rules={[
              {
                required: false,
              },
            ]}
            style={{ width: "20%", marginRight: "10%" }}
          >
            <Checkbox defaultChecked={record?.data?.dirty} />
          </Form.Item>
        </div>
        <div style={{ display: "flex" }}>
          <Form.Item
            label="ShowAudio"
            name="showAudio"
            rules={[
              {
                required: false,
              },
            ]}
            style={{ width: "20%", marginRight: "10%" }}
          >
            <Checkbox defaultChecked={record?.data.showAudio} />
          </Form.Item>
          <Form.Item
            label="ShowVideo"
            name="showVideo"
            rules={[
              {
                required: false,
              },
            ]}
            style={{ width: "20%", marginRight: "10%" }}
          >
            <Checkbox defaultChecked={record?.data.showVideo} />
          </Form.Item>
        </div> */}
                <Form.Item
                    label='Sort'
                    name='sort'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <Select options={SoftOptions} defaultValue={record?.data?.sort} />
                </Form.Item>
                <div className='edit-title'>
                    <Form.Item
                        className='edit-item w48'
                        label='BpmStart'
                        name='bpmStart'
                        rules={[
                            {
                                required: false,
                                message: 'Bpm Start is required',
                            },
                            {
                                min: 50,
                                type: 'number',
                                message: 'BPM Start must be more than 50',
                            },
                            {
                                max: 220,
                                type: 'number',
                                message: 'BPM Start must be less than BMP 220',
                            },
                            {
                                max: bmpEnd,
                                type: 'number',
                                message: 'BPM Start must be less than BMP End',
                            },
                        ]}
                    >
                        <InputNumber defaultValue={record?.data?.bpmStart} type='number' onChange={(value: number) => setBmpStart(value)} />
                    </Form.Item>
                    <Form.Item
                        className='edit-item w48'
                        label='BpmEnd'
                        name='bpmEnd'
                        rules={[
                            {
                                required: false,
                            },
                            {
                                min: bmpStart + 1,
                                type: 'number',
                                message: 'BPM End must be more than BMP Start',
                            },
                            {
                                min: 50,
                                type: 'number',
                                message: 'BPM End must be more than 50',
                            },
                            {
                                max: 220,
                                type: 'number',
                                message: 'BPM End must be less than BMP 220',
                            },
                        ]}
                    >
                        <InputNumber defaultValue={record?.data?.bpmEnd} type='number' onChange={(value: number) => setBmpEnd(value)} />
                    </Form.Item>
                    <Form.Item
                        className='edit-item w48'
                        label='From year'
                        name='yearFrom'
                        rules={[
                            {
                                required: false,
                                message: 'Year is required',
                            },
                            {
                                min: 1950,
                                max: datetimeService.currentYear(),
                                type: 'number',
                                message: `Year must be between 1950 and ${datetimeService.currentYear()}`,
                            },
                        ]}
                    >
                        <InputNumber type='number' defaultValue={record?.data?.yearFrom} />
                    </Form.Item>
                    <Form.Item
                        className='edit-item w48'
                        label='To year'
                        name='yearTo'
                        rules={[
                            {
                                required: false,
                                message: 'Year is required',
                            },
                            {
                                min: 1950,
                                max: datetimeService.currentYear(),
                                type: 'number',
                                message: `Year must be between 1950 and ${datetimeService.currentYear()}`,
                            },
                        ]}
                    >
                        <InputNumber type='number' defaultValue={record?.data?.yearTo} />
                    </Form.Item>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Form.Item
                        className='edit-item w48'
                        label='Clean'
                        name='clean'
                        rules={[
                            {
                                required: false,
                            },
                        ]}
                    >
                        <Switch defaultChecked={record?.data?.clean} />
                    </Form.Item>
                    <Form.Item
                        className='edit-item w48'
                        label='Dirty'
                        name='dirty'
                        rules={[
                            {
                                required: false,
                            },
                        ]}
                    >
                        <Switch defaultChecked={record?.data?.dirty} />
                    </Form.Item>
                    <Form.Item
                        className='edit-item w48'
                        label='ShowAudio'
                        name='showAudio'
                        rules={[
                            {
                                required: false,
                            },
                        ]}
                    >
                        <Switch defaultChecked={record?.data?.showAudio} />
                    </Form.Item>
                    <Form.Item
                        className='edit-item w48'
                        label='ShowVideo'
                        name='showVideo'
                        rules={[
                            {
                                required: false,
                            },
                        ]}
                    >
                        <Switch defaultChecked={record?.data?.showVideo} />
                    </Form.Item>
                </div>
            </Form>
        </Edit>
    );
};
